

.beige
{
  .choices {
    .checked {

      border-color: var(--beigedarker);
      background-color: var(--beige);
    }
  }
}
.choicesContainer {
  margin-bottom: 1.25em;

  .choices {
    display: flex;
    gap: 1.25em;
    flex-wrap: wrap;


    & > * {
      border: 1px solid var(--beigedarker);
      border-radius: var(--border-radius);
      position: relative;
      padding: 1.25em 2em 1.25em 1.25em;
      flex-grow: 1;
      cursor: pointer;

      &:hover {
        box-shadow: 5px 5px 8px 0 rgba(0, 0, 0, 0.1);
      }

      &.checked {
        box-shadow: 5px 5px 8px 0 rgba(0, 0, 0, 0.1);
        background-color: white;
      }

      &:first-child {
        //width: 100%;
      }

      .radio {
        position: absolute;
        top: 0.75em;
        right: 0.75em;

      }
    }
  }
}